import { Building, Globe, User, Users } from "lucide-react";

import type { Layer } from "@/api/overrides";
import { Badge } from "@/components/ui/badge";

const META: Record<Layer, { label: string; icon: JSX.Element; color: string }> = {
  platform: {
    label: "Platform",
    icon: <Globe className="size-3 mr-1" />,
    color: "bg-purple-100 text-purple-800 border-purple-300",
  },
  tenant: {
    label: "Tenant",
    icon: <Building className="size-3 mr-1" />,
    color: "bg-blue-100 text-blue-800 border-blue-300",
  },
  role: {
    label: "Role",
    icon: <Users className="size-3 mr-1" />,
    color: "bg-green-100 text-green-800 border-green-300",
  },
  personal: {
    label: "Cá nhân",
    icon: <User className="size-3 mr-1" />,
    color: "bg-orange-100 text-orange-800 border-orange-300",
  },
};

export function LayerIndicator({ layer }: { layer: Layer }): JSX.Element {
  const meta = META[layer];
  return (
    <Badge variant="outline" className={`text-[10px] border ${meta.color}`}>
      {meta.icon}
      {meta.label}
    </Badge>
  );
}
